import jsPDF from 'jspdf';

export const generatePurchasedMerchandisePDF = (purchasedItems) => {
    const doc = new jsPDF();
    const margin = 14;
    let cursorY = margin + 8;
    const pageHeight = doc.internal.pageSize.height;

    // Helper function to add a new page and reset cursor  
    const addNewPage = () => {
        doc.addPage();
        cursorY = margin;
    };

    // Add title  
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('Purchased Merchandise', margin, cursorY);
    cursorY += 8;

    // Add a divider line  
    doc.setLineWidth(0.5);
    doc.line(margin, cursorY, pageHeight - margin, cursorY);
    cursorY += 8;

    // Add merchandise details  
    purchasedItems.forEach(item => {
        const itemName = item.description ?? "Unknown Item";
        const itemPrice = item.price ?? 0;

        // Add item name as a title  
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text(`Item: ${itemName}`, margin, cursorY);
        cursorY += 6;

        // Add price in smaller font  
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(`Price: R${itemPrice}`, margin, cursorY);
        cursorY += 6;

        // Add a divider line between items  
        doc.line(margin, cursorY, pageHeight - margin, cursorY);
        cursorY += 6;

        // Check if we need a new page  
        if (cursorY + 6 > pageHeight) addNewPage();
    });

    // Calculate total price  
    const totalPrice = purchasedItems.reduce((sum, item) => sum + (item.price || 0), 0);

    // Add total price at the end of the list  
    cursorY += 10; // Add some space before the total price  
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`Total Price: R${totalPrice.toFixed(2)}`, margin, cursorY);

    // Save the PDF  
    doc.save('Purchased_Merchandise.pdf');
};  
